import React from 'react'
import { components } from 'react-select'
import makeAnimated from 'react-select/animated'
const allOption = {
  label: 'Select all',
  value: 'All',
}
export const Option = props => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ color: '#4b4acb' }}
        />{' '}
        <label style={{ color: '#4b4acb' }}>{props.label}</label>
      </components.Option>
    </div>
  )
}
export const ValueContainer = ({ children, ...props }) => {
  const currentValues = props.getValue()
  let toBeRendered = children
  if (currentValues.some(val => val.value === allOption.value)) {
    toBeRendered = [[children[0][0]], children[1]]
  }
  return (
    <components.ValueContainer {...props}>
      {toBeRendered}
    </components.ValueContainer>
  )
}

export const MultiValue = props => {
  let labelToBeDisplayed = `${props.data.label}`
  if (props.data.value === allOption.value) {
    labelToBeDisplayed = 'All items are selected.'
  }
  return (
    <components.MultiValue {...props}>
      <span>{labelToBeDisplayed}</span>
    </components.MultiValue>
  )
}

export const AnimatedComponents = () => makeAnimated()
